export default "__VITE_ASSET__CsdJGmHk__"